import {
    Home,
    Users,
    Star,
    ShoppingBag,
    Map,
    Monitor,
    Settings,
    MapPin,
    Activity,
    Command,
    Compass,
    Anchor,
    Server,
    CloudOff,
    Database,
    Octagon,
    Calendar,
    Radio,
    Terminal
} from 'react-feather';


export const MENUITEMS = [
    {
        title: 'Dashboard', icon: Home, type: 'link', path: '/dashboard', badgeType: 'primary', active: false
    },
    {
        title: 'Classes', icon: Map, type: 'link', path: '/classes', active: false
    },
    //  {
    //     title: 'Timetable', icon: Terminal, type: 'link', path:'/timetable',active: false
    // },
    {
        title: 'Amalan Baik', icon: Anchor, type: 'sub', path: '/amalanBaik', children: [
            { path: '/amalanBaikDashboard', type: 'link', title: 'Analytics' },
            { path: '/amalanBaik', type: 'link', title: 'List of Amalan Baik' }
            // { path: '/goodDeeds/students', type: 'link', title: 'Students Achievement' },
            // { path: '/employee', type: 'link', title: 'Employee User' }
        ]
    },
    {
        title: 'Masalah Disiplin', icon: Octagon, type: 'sub', path: '/masalahDisiplinList', children: [
            { path: '/masalahDisiplinDashboard', type: 'link', title: 'Analytics' },
            { path: '/masalahDisiplinList', type: 'link', title: 'List of Masalah Disiplin' }
        ]
    },
    {
        title: 'Late Comer', icon: Compass, type: 'link', path: '/lateComer', active: false
    },
    {
        title: 'Bulletin', icon: Activity, type: 'link', path: '/bulletin', active: false
    },
    {
        title: 'RMT', icon: Radio, type: 'link', path: '/rmt', active: false
    },
    {
        title: 'Gates', icon: MapPin, type: 'link', path: '/gate', active: false
    },
    {
        title: 'Feedback', icon: Command, type: 'link', path: '/feedback', active: false
    },
    {
        title: 'Merchant', icon: ShoppingBag, type: 'link', path: '/merchant', active: false
    },
    {
        title: 'Teacher', icon: Monitor, type: 'link', path: '/teacher', active: false
    },

    {
        title: 'Student', icon: Star, type: 'sub', active: false, children: [
            { path: '/student', type: 'link', title: 'Students' },
            // { path: '/employee', type: 'link', title: 'Employee User' }
        ]
    },
    {
        title: 'Users', icon: Users, type: 'sub', active: false, children: [
            { path: '/portalUser', type: 'link', title: 'Portal User' }
        ]
    },

    // {
    //     title: 'Custom Attendance', icon: Tool, type: 'link', path:'/customAttendance',active: false
    // },
    {
        title: 'Holidays', icon: Calendar, type: 'link', path: '/schoolHolidayConfig', active: false
    },
    {
        title: 'Configurations', icon: Server, type: 'link', path: '/schoolConfiguration', active: false
    },
    {
        title: 'Download', icon: Database, type: 'link', path: '/downloadAttendance', active: false
    },
    {
        title: 'Audit', icon: CloudOff, type: 'link', path: '/auditLog', active: false
    },
    {
        title: 'Settings', icon: Settings, type: 'link', path: '/settings', active: false
    },
]
